<div class="search-form">
  <div class="input-group flex-nowrap">
    <span class="input-group-text" id="addon-wrapping">
      <i class="bi bi-search fw-bold"></i>
    </span>
    <input (keydown.enter)="search()" type="search" [(ngModel)]="paginationOptions.search"
      placeholder="Type to search..." class="form-control form-control-solid ps-0 search-field" aria-label="Search"
      aria-describedby="addon-wrapping" />
    <input class="form-control form-control-solid ps-0 search-by-label" [readOnly]="true" value="SEARCH BY:" />
    <app-custom-select [title]="'Select Option'" [(ngModel)]="selectedSearchField" [options]="getSearchFields()"
      [showSearch]="true" (ngModelChange)="onSearchFieldChanged()" [showIcon]="false">
    </app-custom-select>
    <button *ngIf="paginationOptions.search?.length" (click)="search()"
      class="btn btn-lg btn-primary text-white fw-bold"><i class="bi bi-search me-2 fw-semibold"></i> Look Up</button>
    <button *ngIf="!paginationOptions.search?.length" (click)="search()"
      class="btn btn-lg btn-primary text-white fw-bold"><i class="bi bi-arrow-clockwise me-2 fw-bold"></i>
      Reload</button>
  </div>
</div>
